<template>
  <!--  노션 링크 : https://www.notion.so/GolfpracticePage-f1d3590851ef4043b3c33b78e493ecc9 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="golfpractice_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">GOLF PRACTICE</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="contentDesc">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 0 || isLang === 1}">
          <div class="title1">
            <h2>
              <strong>{{ $t('golfpractice_title') }}</strong>
            </h2>
          </div>
          <div class="title2">
            <h4>{{ $t('golfpractice_subtitle') }}</h4>
          </div>
          <div class="title3">
            <p>{{ $t('golfpractice_desc1') }}</p>
          </div>
        </div>
      </div>
    </div>

    <GallerySlideCarousels :slides="slides" :slide-count="4" :thumb-slide-width="50" />

    <div class="container mt-5 mb-5">
      <div class="row justify-content-center">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <td width="31%" class="align-items-center">{{ $t('golfpractice_table_td1') }}</td>
              <td>{{ $t('golfpractice_table_td2') }}</td>
            </tr>
            <tr>
              <td>{{ $t('golfpractice_table_td3') }}</td>
              <td v-html="$t('golfpractice_table_td4')"></td>
            </tr>
            <tr>
              <td>{{ $t('golfpractice_table_td5') }}</td>
              <td>{{ $t('golfpractice_table_td6') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GallerySlideCarousels from '@/components/GallerySlideCarousels';
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'GolfpracticePage',
  data() {
    return {
      golfpractice_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'FACILITIES',
        present: this.$t('breadcrumb'),
      },
      slides: [
        {image: require('@/assets/images/Golf/golfpractice_bodyimage01.jpg')},
        {image: require('@/assets/images/Golf/golfpractice_bodyimage02.jpg')},
        {image: require('@/assets/images/Golf/golfpractice_bodyimage03.jpg')},
        {image: require('@/assets/images/Golf/golfpractice_bodyimage04.jpg')},
      ],
      index: 0, // default: 0,
      isLang: 0,
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.golfpractice_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'FACILITIES',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  components: {
    GallerySlideCarousels,
    Breadcrumb,
  },
};
</script>

<style scoped lang="scss">
.jpword {
  word-break: break-all;
}
.anotherword {
  p,
  h1,
  h2,
  h3,
  h4,
  h5 {
    word-break: keep-all;
  }
}
td {
  border-bottom: 1px dashed #cdcdcd;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}

.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
@media (max-width: 992px) {
  .main-ex-img {
    margin-bottom: 50px;
  }
  .main-ex-desc {
    vertical-align: center;
    text-align: center;
  }
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  h4 {
    font-size: 1.2rem !important;
    font-weight: 600;
    padding: 0 1rem;
  }
  p {
    font-size: 0.9rem !important;
    padding: 0 1rem;
  }
}
@media (min-width: 992px) {
  .main-ex-desc {
    vertical-align: bottom;
  }
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Golf/golfpractice_headerimage.png');
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "어프로치 존",
    "golfpractice_title": "어프로치 존",
    "golfpractice_subtitle": "정교한 숏게임을 위한 어프로치 & 벙커 연습장",
    "golfpractice_desc1": "그린 주변에서의 정확한 거리감과 정교한 컨트롤을 익히며 어프로치와 벙커샷을 집중적으로 연습할 수 있는 공간입니다.",
    "golfpractice_table_td1": "이용시간",
    "golfpractice_table_td2": "07:00 ~ 17:00 (골프장 휴장 시 Close)",
    "golfpractice_table_td3": "이용안내",
    "golfpractice_table_td4": "- 타구 제한 거리 20m<br>- 기존 매트 타석 사용 불가<br>- 샷 하기 전 2m이상 거리 유지<br>- 벙커 연습 시 동시 최대 2인 사용<br>- 연습장 내 음주 및 고성 금지",
    "golfpractice_table_td5": "문의",
    "golfpractice_table_td6": "064-793-5042"
  },

  "en":{
    "breadcrumb": "Approach Zone",
    "golfpractice_title": "Approach Zone",
    "golfpractice_subtitle": "Approach & Bunker Practice Range for Precise Short Games",
    "golfpractice_desc1": "This is a dedicated space to practice approach shots and bunker shots, allowing you to master accurate distance control and precise technique around the green.",
    "golfpractice_table_td1": "Operating Hours",
    "golfpractice_table_td2": "07:00 ~ 17:00 (Closed when the golf club is closed)",
    "golfpractice_table_td3": "Guidelines",
    "golfpractice_table_td4": "- Do not hit the ball more than 20 meters for safety reasons.<br>- The existing mat hitting stations are not available for use.<br>- Keep a distance of at least 2 meters before swinging.<br>- A maximum of two people are allowed in the bunker practice range.<br>- Drinking alcohol and loud talking are prohibited in the practice range.",
    "golfpractice_table_td5": "Inquiries",
    "golfpractice_table_td6": "+82-64-793-5042"
  },

  "ja": {
    "breadcrumb": "ゴルフ練習場",
    "golfpractice_title": "ゴルフ練習場",
    "golfpractice_subtitle": "プレーそのままに練習する広く快適な練習場",
    "golfpractice_desc1": "実際のフェアウェイと同じ西洋芝で、正式なプレーの感覚に最も近い環境の中で楽に練習することができ、バンカーショットを練習することのできるスペースもあります。",
    "golfpractice_table_td1": "Operating Hours",
    "golfpractice_table_td2": "07:00 ~ 17:00 (Closed when the golf club is closed)",
    "golfpractice_table_td3": "Guidelines",
    "golfpractice_table_td4": "- Do not hit the ball more than 20 meters for safety reasons.<br>- Keep a distance of at least 2 meters before swinging.<br>- A maximum of two people are allowed in the bunker practice range.<br>- Drinking alcohol and loud talking are prohibited in the practice range.",
    "golfpractice_table_td5": "Inquiries",
    "golfpractice_table_td6": "+82-64-793-5042"
  }
}
</i18n>
